"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiActionRenderers = void 0;
var UiActionRenderers;
(function (UiActionRenderers) {
    UiActionRenderers["BUTTON"] = "Button";
    UiActionRenderers["BUTTON_ICON"] = "ButtonIcon";
    UiActionRenderers["LINK_BUTTON"] = "LinkButton";
    UiActionRenderers["LINK_BUTTON_ICON"] = "LinkButtonIcon";
    UiActionRenderers["HTML_ANCHOR"] = "HTMLAnchor";
})(UiActionRenderers = exports.UiActionRenderers || (exports.UiActionRenderers = {}));
